"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT = void 0;
const tab_1 = require("../../../tab");
exports.NOT = {
    description: 'returns the negation of the expression',
    arg_names: ['expression'],
    args_def: [
        {
            types: ['boolean'],
            required: true,
        },
    ],
    args_description: ['a boolean expression'],
    return_type: tab_1.ColumnType.BOOLEAN,
};
